import React, { useEffect, useState } from "react";
import DynamicTable from "../../../Components/InputComponents/LookupView";
import { Edit, Delete, Visibility } from "@mui/icons-material";
import { useNavigate, useSearchParams } from "react-router-dom";
import { axiosAPI } from "../../../Components/AxiosComponents/Axios";
import { encryptId } from "../../../Components/CryptoComponent";
import { useStaffLayout } from "../../../Components/Context/CandidateLayoutContext";

function QualificationList({ isAdmin }) {
  const navigate = useNavigate();

  const { privilegeData } = useStaffLayout();

  function hasQualAddprivilege(privilegeData) {
    if (isAdmin) return true;
    return privilegeData.some((subModule) => {
      const isClient = subModule.subModuleName
        .toLowerCase()
        .includes("qualification");
      if (!isClient) return false;

      return subModule.privileges.some(
        (priv) =>
          priv.privilegeName.toLowerCase() === "add" && priv.assigned === true
      );
    });
  }

  function hasQualEditprivilege(privilegeData) {
    if (isAdmin) return true;
    return privilegeData.some((subModule) => {
      const isClient = subModule.subModuleName
        .toLowerCase()
        .includes("qualification");
      if (!isClient) return false;

      return subModule.privileges.some(
        (priv) =>
          priv.privilegeName.toLowerCase() === "edit" && priv.assigned === true
      );
    });
  }

  const columns = [
    { field: "QL_Id", label: "#" },
    { field: "QL_Name", label: "Qualification" },
    { field: "QL_Status", label: "Status" },
  ];

  const [searchParams] = useSearchParams();

  const actions = [
    hasQualEditprivilege(privilegeData) && {
      icon: Edit,
      handler: (row) => {
        const encrypted = encodeURIComponent(encryptId(row?.QL_Id));

        navigate(
          `/QualificationLookup/Edit/${encrypted}?${searchParams.toString()}`
        );
      },
      color: "warning",
    },
  ].filter(Boolean); // Remove falsy values if privilege check fails
  return (
    <DynamicTable
      columns={columns}
      dataAPI={`/Qualification/list`}
      actions={actions}
      title={`Qualification`}
      {...(hasQualAddprivilege(privilegeData) && {
        linkvalue: `/QualificationLookup/Add?${searchParams.toString()}`,
      })}
    />
  );
}

export default QualificationList;
